import styled from 'styled-components';

import { colors } from '../../constants';

export const SubmitButton = styled.button.attrs(() => ({
    type: 'submit',
}))`
    appearance: none;
    display: block;
    padding: 0 70px;
    height: 56px;
    margin-top: 60px;
    font-family: inherit;
    text-align: center;
    color: ${colors.white};
    background: ${colors.primary};
    border-radius: 5px;
    border: 0;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.15s linear;

    &:focus {
        outline: 0;
    }

    // Overriding PBE hover styles
    :hover {
        text-decoration: none;
        color: ${colors.white};
        background-color: ${colors.orangeHover};
    }

    &:disabled {
        background: ${colors.greyLight};
        cursor: default;
    }
`;
